(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lensun-energy-hero"] && !Shopify.designMode) return;
  try {
    
  (()=>{document.querySelectorAll('.lensun-hero').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const slides=[...root.querySelectorAll('[data-slide]')],dots=[...root.querySelectorAll('[data-dot]')],reduce=matchMedia('(prefers-reduced-motion: reduce)');if(slides.length<2)return;let index=0,timer;const show=next=>{index=(next+slides.length)%slides.length;slides.forEach((slide,i)=>{const active=i===index;slide.classList.toggle('is-active',active);slide.setAttribute('aria-hidden',String(!active))});dots.forEach((dot,i)=>dot.classList.toggle('is-active',i===index))};const stop=()=>clearInterval(timer);const start=()=>{stop();if(root.dataset.autoplay==='true'&&!reduce.matches&&!document.hidden)timer=setInterval(()=>show(index+1),Number(root.dataset.interval)||8000)};root.querySelector('[data-prev]')?.addEventListener('click',()=>{show(index-1);start()});root.querySelector('[data-next]')?.addEventListener('click',()=>{show(index+1);start()});dots.forEach((dot,i)=>dot.addEventListener('click',()=>{show(i);start()}));root.addEventListener('mouseenter',stop);root.addEventListener('mouseleave',start);document.addEventListener('visibilitychange',()=>document.hidden?stop():start());reduce.addEventListener?.('change',start);start()})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lensun-mega-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const header = document.querySelector('[data-le-header]');
    if (!header) return;
    const toggle = header.querySelector('[data-le-toggle]');
    const nav = header.querySelector('[data-le-nav]');
    const closeNavigation = () => {
      nav.classList.remove('is-open');
      toggle?.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('overflow-hidden');
    };
    toggle?.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
      document.documentElement.classList.toggle('overflow-hidden', open);
    });
    nav.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeNavigation));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeNavigation();
        header.querySelectorAll('details[open]').forEach((item) => item.open = false);
        toggle?.focus();
      }
    });
    matchMedia('(min-width:1121px)').addEventListener?.('change', (event) => {
      if (event.matches) closeNavigation();
    });
    header.querySelectorAll('[data-le-mega]').forEach((item) => {
      item.addEventListener('mouseenter', () => {
        if (matchMedia('(min-width:1121px)').matches) item.open = true;
      });
      item.addEventListener('mouseleave', () => {
        if (matchMedia('(min-width:1121px)').matches) item.open = false;
      });
    });
    document.addEventListener('click', (event) => {
      if (!header.contains(event.target)) header.querySelectorAll('details[open]').forEach((item) => item.open = false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
